<div class="page">
  <div class="container">
    <div class="page-header text-center">
      <p class="text-overline color--primary">Application Verification
      </p>
      <mat-card>
        <h1 class="mat-display-1">Thank you!</h1>
        <p class="mat-subheading-1">Check your inbox for a confirmation email.</p>
      </mat-card>
    </div>
  </div>
</div>
